import { useState, useEffect } from 'react';
import { LOGIN_VARIANTS_ENDPOINT } from '../constants';
import { DynamicVariantProps } from '../interfaces/variant';
import {
  getDynamicVariant,
  getLoginVariantsJsonFilePath
} from '../utils/variant-utils';

export type LoginVariantsHookResponse = {
  loginVariant: DynamicVariantProps | null;
  hasError: boolean;
};

const useLoginVariants = (): LoginVariantsHookResponse => {
  const [loginVariant, setLoginVariant] = useState<DynamicVariantProps | null>(
    null
  );
  const [hasError, setHasError] = useState(false);

  const jsonFilePath = getLoginVariantsJsonFilePath();

  useEffect(() => {
    const fetchLoginVariants = async (): Promise<void> => {
      try {
        const response = await fetch(
          `${LOGIN_VARIANTS_ENDPOINT}${jsonFilePath}`
        );
        const data = await response.json();
        setHasError(false);
        setLoginVariant(getDynamicVariant(data));
      } catch (error) {
        setHasError(true);
        throw new Error(`Failed fetching login variants: ${error}`);
      }
    };

    fetchLoginVariants();
  }, [jsonFilePath]);

  return {
    loginVariant,
    hasError
  };
};

export default useLoginVariants;
